module.exports = __webpack_public_path__ + "static/media/Frederik Brudy.94a0aa4e.png";